import logToLoggly from '../../shared/lib/loggly'
import configFromParams from '../../client/lib/params'

import {
  ACTIVITY_FAILURE,
  LOAD_PROGRESS_FAILURE,
  CHALLENGE_FAILURE,
  INIT_ASSIGNMENT_FAILURE,
  LOAD_MACMILLAN_FAILURE,
  LOAD_STUDENT_ROSTER_FAILURE,
  SAVE_PROGRESS_FAILURE
} from '../../client/actions'
import {
  LCRP_PROGRESS_FAILURE,
  LCRP_SAVE_FAILURE,
  LCRP_GET_ALL_ACTIVITIES_FAILURE
} from '../../lcrp/actions'

export default function ({ dispatch, getState }) {
  const config = configFromParams()

  return next => action => {
    if (action.type.includes('_FAILURE')) {
      switch (action.type) {
        case ACTIVITY_FAILURE:
          logToLoggly('React: Failed to load activity:' + config.file, 'WARN')
          break
        case LOAD_PROGRESS_FAILURE:
          logToLoggly('React: Progress failed to load for user/assignment:' +
          JSON.stringify(getState().core.initialUserData), 'WARN')
          break
        case CHALLENGE_FAILURE:
          logToLoggly('React: Failed to send challenge question.', 'WARN')
          break
        case INIT_ASSIGNMENT_FAILURE:
          logToLoggly('React: Failed to initialize assignment.', 'WARN')
          break
        case LOAD_MACMILLAN_FAILURE:
          logToLoggly('React: Failed to load Macmillan.', 'WARN')
          break
        case LCRP_PROGRESS_FAILURE:
          logToLoggly('React: Failed to load LCRP Progress.', 'WARN')
          break
        case LCRP_SAVE_FAILURE:
          logToLoggly('React: Failed to save LCRP Progress.', 'WARN')
          break
        case LOAD_STUDENT_ROSTER_FAILURE:
          logToLoggly('React: Failed to load LCRP Student Roster.', 'INFO')
          break
        case LCRP_GET_ALL_ACTIVITIES_FAILURE:
          logToLoggly('React: Failed to fetch all activity titles in a course', 'INFO')
          break
        case SAVE_PROGRESS_FAILURE:
          logToLoggly('React: Progress failed to save for user/assignment:' +
            JSON.stringify(getState().core.initialUserData) + '. Possible connection loss.', 'WARN')
          break
        default:
          // attempt to future proof; console log any future failure not being sent to Loggly
          console.log('React: Failure not currently sent to Loggly: ' + action.type)
          break
      }
      console.log('JS error action type: ' + action.type)
      console.log('Application state at failure', getState().core)
    }

    // Dev NOTE: Always return this at the very end
    return next(action)
  }
}
